import React from 'react';
import valuesVideo from '../assets/images/misc/BMCS.mp4.mp4';

const ValuesSection: React.FC = () => {
  return (
    <section id="values" className="values-section">
      <div className="container values-section__inner">
        <div className="row align-items-center g-3 g-lg-4">
          <div className="col-12 col-lg-6">
            <div className="values-block">
              <span className="section-eyebrow">Our Values</span>
              <h2 className="section-title values-block__title">Compassion, integrity, and unity</h2>
              <p className="values-lead">
                At Bothasig Muslim Cultural Society, we believe in compassion, integrity, and unity. Our
                values guide everything we do, from our community events to our educational programs.
              </p>
              <p className="values-body mb-0">
                We are dedicated to supporting each other and building a nurturing environment where
                everyone feels at home. By embracing diversity and promoting understanding, we create a
                strong foundation for our growing community. We invite you to join us on this journey of
                growth and faith—whether through our fundraising initiatives, engaging classes, or
                spiritual gatherings, there&apos;s a place for you here. Together, we thrive!
              </p>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="values-video-wrap">
              <video
                className="values-video"
                src={valuesVideo}
                controls
                playsInline
                poster=""
                aria-label="BMCS our values video"
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
